import * as React from "react";
var TemplatePosition = function (_a) {
    var area = _a.area, children = _a.children;
    return (React.createElement(React.Fragment, null, children));
};
export default TemplatePosition;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/template/templatePosition.tsx
// module id = B6TH
// module chunks = 2